import BaseLayout from "layouts/base-layout";
import React, { useEffect, useState } from "react";
import RenderModules from "helpers/render-modules";
import MetaTags from "components/meta";

const Page = ({ pageContext, location: { pathname } }) => {
    const { content, settings, template } = pageContext;
   
    return (
        <BaseLayout settings={settings} path={pathname}>
            <div className={template === "other" ? "container" : ""}>
                <div className={template === "other" ? "container--other-pages" : ""}>
                    {content.modules && <RenderModules modules={content.modules} />}
                </div>
            </div>
        </BaseLayout>
    );
};

const generateFAQschema = (faqSection) => {
    if (!faqSection || !Array.isArray(faqSection)) return null;

    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqSection.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
            },
        })),
    };

    return schema;
};

const setExtraMeta = (pageContext) => {
    let handle = pageContext?.handle?.current;
    if (typeof handle !== "string") return [];

    if (handle?.startsWith("/")) handle = handle.slice(1);

    const faqSection = pageContext?.meta?.faqSection;
    const faqSchema = generateFAQschema(faqSection);

    const extraMetaTags = [
        {
            type: "link",
            content: (
                <link
                    key="canonical-link"
                    rel="canonical"
                    href={`https://sealskincovers.com/${handle}`}
                />
                
            ),
        },
    ];

    if (faqSchema) {
        extraMetaTags.push({
            type: "script",
            content: (
                <script
                    type="application/ld+json"
                >
                    {JSON.stringify(faqSchema)}
                </script>
            ),
        });
    }

    return extraMetaTags;
};

export const Head = ({ pageContext }) => (
    <MetaTags
        meta={pageContext.meta ?? { title: pageContext.title }}
        extra={setExtraMeta(pageContext)}
    />
);

export default Page;
